// Note: Slack messages are sent via the backend API endpoint, not directly to Slack

export const sendToSlack = async (
  message: string,
  metadata: Record<string, any>,
): Promise<boolean> => {
  const payload = {
    username: '🚨 Mobile App Support Request',
    blocks: [
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `*Message:*\n${message}`,
        },
      },
      {
        type: 'context',
        elements: [
          {
            type: 'mrkdwn',
            text: `*Metadata:* \`${JSON.stringify(metadata, null, 2)}\``,
          },
        ],
      },
    ],
  };

  console.log('Sending to Slack:', payload);
  console.log('Slack Payload:', JSON.stringify(payload, null, 2));

  const apiUrl = import.meta.env.VITE_API_URL + '/user-message';
  const token = localStorage.getItem('jwtToken');

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        message: JSON.stringify(payload),
      }),
    });

    console.log('Slack response status:', response.status);

    if (!response.ok) {
      console.error('Failed to send message to Slack:', response.statusText);
      return false;
    }
  } catch (error) {
    console.error('Error sending message to Slack:', error);
    return false;
  }
  console.log('Message sent to Slack successfully');

  return true;
};
